import { render } from "./toggle-switch.vue?vue&type=template&id=e50dc3c6"
import script from "./toggle-switch.vue?vue&type=script&lang=js"
export * from "./toggle-switch.vue?vue&type=script&lang=js"

import "./toggle-switch.vue?vue&type=style&index=0&id=e50dc3c6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__